import { Component, inject } from '@angular/core';
import { BrnDialogImports, BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { Étape } from '../../../models/étape.model';

@Component({
  selector: 'app-dialog-conflit-etape',
  imports: [HlmDialogImports, HlmButtonImports, BrnDialogImports],
  templateUrl: './dialog-conflit-étape.component.html',
})
export class DialogConflitÉtapeComponent {
  readonly #dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);

  readonly #dialogContext = injectBrnDialogContext<{ étape: Étape }>();

  readonly etape = this.#dialogContext.étape;

  confirm() {
    this.#dialogRef.close(true);
  }
}
